import React, { useState } from "react";
import VbsForm from "./VbsForm";
import PolicyForm from "./PolicyForm";
import RegistrationComplete from "./RegistrationComplete";
import { registerVbs } from "./api";

export default function VbsRegistrationFlow() {
  const [step, setStep] = useState("form");
  const [formData, setFormData] = useState({});
  const [registered, setRegistered] = useState(false);

  const restart = () => {
    setStep("form");
    setFormData({});
    setRegistered(false);
  };

  if (step === "form") {
    return (
      <VbsForm
        onComplete={(vbsData) => {
          setFormData((prev) => ({ ...prev, ...vbsData }));
          setStep("policy");
        }}
      />
    );
  }

  if (step === "policy") {
    return (
      <PolicyForm
        formData={formData}
        onAgree={async (policyData) => {
          const finalData = { ...formData, ...policyData, formType: "vbs" };
          try {
            await registerVbs(finalData);
            setRegistered(true);
            setStep("complete");
          } catch (err) {
            alert("VBS submission failed. Please try again.");
          }
        }}
      />
    );
  }

  return <RegistrationComplete onRestart={restart} registered={registered} />;
}
